import { Token } from "../services/login";
import moment from "moment";


//token 存储
export const tokenStorage = {
    set: (token: Token)=>{
        localStorage.setItem("token", JSON.stringify(token));
    },

    get: (): Token | null =>{
        const jsonStr = localStorage.getItem("token");
        if (!jsonStr) {
            return null;
        }
        return  JSON.parse(jsonStr);
    },

    remove: ()=>{
        localStorage.removeItem("token");
    }
}


//是否已经回答过问卷
export const answerStorage = {
    set: (questionnaireId: number)=>{
        localStorage.setItem(`answer:${questionnaireId}`, moment().format("YYYY-MM-DD HH:mm:ss"));
    },

        get: (questionnaireId: number) =>{
        return  localStorage.getItem(`answer:${questionnaireId}`);
    },

    remove: (questionnaireId: number)=>{
        localStorage.removeItem(`answer:${questionnaireId}`);
    }
}
